<div class="px-2 charts-wrapper" *ngIf="shouldShow | async">
  <ngx-charts-bar-vertical
    [view]="view"
    [scheme]="colorScheme"
    [results]="single"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [legend]="showLegend"
    legendTitle="Status"
    [showXAxisLabel]="false"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    (select)="onSelect($event)"
  >
  </ngx-charts-bar-vertical>
</div>
